import React from 'react'

function Facil({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" {...r}>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M50.57 45.73c-.39 4.4-3.78 5.58-3.87 5.84l.09 8.19M25.3 37.59l-3.38-3.28c-2.25-1.99-5.36-2.39-7.96-1.29-1.82.77-2.12 2.5-.67 3.84l3.77 3.47L27.1 51.71m5.68-19.65l-.08-9.26 2.01-.02a3.918 3.918 0 013.95 3.88l.05 5.34"
      ></path>
      <path
        stroke="#00033A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M38.75 32.43l-.11-7.12 2.01-.02a3.918 3.918 0 013.95 3.88l.05 5.34m.07.44l-.11-7.12 2.01-.02a3.912 3.912 0 013.95 3.88l.07 13.66M32.75 31.09l-.13-16.93c-.02-1.84-1.68-3.32-3.71-3.3-2.01.02-3.64 1.49-3.65 3.31l.21 23.37m1.64 14.18l.05 8.19"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M21.84 23.88a11.405 11.405 0 01-5.06-9.48c0-6.3 5.11-11.41 11.41-11.41S39.6 8.1 39.6 14.4c0 1.05-.14 2.07-.41 3.03"
      ></path>
    </svg>
  )
}

export default Facil